import { recieveCategories } from "./reducer";
import { APIClient } from "../../../helpers/api_helper";
const api = new APIClient();

export const loadCategories = () => async (dispatch, getState) => {

    try {
        const data = await api.get('/api/categories/get_options/')

        if (data) {
            dispatch(recieveCategories(data));
        }
    } catch (error) {
        console.error('Unable to load categories!', error)
    }
};
